import { SET_ALERT, SET_ALERT_VISIBILITY } from "./types";

export const setAlert = (alertContent, alertVariant, timeout = 3000) => dispatch => {
  dispatch(
    {
      type: SET_ALERT,
      payload: {
        alertContent: alertContent,
        alertVariant: alertVariant
      }
    }
  );
  dispatch({
    type: SET_ALERT_VISIBILITY,
    payload: true
  });
  setTimeout(() => {
    dispatch({
      type: SET_ALERT_VISIBILITY,
      payload: false
    })
  }, timeout);
};

export const setAlertVisibility = toggle => dispatch => {
  dispatch({
    type: SET_ALERT_VISIBILITY,
    payload: toggle
  });
};
